export default __webpack_public_path__ + "static/media/edit.cd762f81.svg";